import Joi from 'joi';
import { appHandlerForJoiErrors } from '../../utils';
import { appTimeRegExp } from '../../constants';

const offerScheduleLabels = {
  day: 'Day',
  timeFrom: 'Time from',
  timeTo: 'Time to',
};

const daySchema = Joi.number()
  .label(offerScheduleLabels.day)
  .min(0)
  .max(7)
  .error(appHandlerForJoiErrors)
  .required();

const timeFromSchema = Joi.string()
  .label(offerScheduleLabels.timeFrom)
  .pattern(appTimeRegExp())
  .error(appHandlerForJoiErrors)
  .trim()
  .required();

const timeToSchema = Joi.string()
  .label(offerScheduleLabels.timeTo)
  .pattern(appTimeRegExp())
  .error(appHandlerForJoiErrors)
  .trim()
  .required();

export const offerScheduleSchema = Joi.object({
  schedules: Joi.array().items(
    Joi.object({
      day: daySchema,
      timeFrom: timeFromSchema,
      timeTo: timeToSchema,
    }),
  ),
});
